module.exports = __webpack_public_path__ + "img/5.42d4b127.png";